import { apiFetch } from 'services/apiClient';
import { Page } from '../../../types/Page';
import { Answer, StandardAnswerCreateResponse } from '../types/Answer';

export const listAnswers = (page = 0, size = 10, sort?: string, query?: string): Promise<Page<Answer>> =>
  apiFetch('/answers?page=' + page + '&size=' + size + (sort ? '&sort=' + sort : '') + (query ? '&' + query : ''));
// Fetch all answers; optional query supports filters like 'questionId.equals=123'.
export const listAnswersAll = (
  query?: string,
  sort: string = 'sortOrder,asc',
): Promise<Answer[]> =>
  apiFetch('/answers/all' + (sort ? '?sort=' + sort : '') + (query ? (sort ? '&' : '?') + query : ''));
export const getAnswer = (id: number): Promise<Answer> => apiFetch('/answers/' + id);
export const createAnswer = (data: any): Promise<Answer> =>
  apiFetch('/answers', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const updateAnswer = (id: number, data: any): Promise<Answer> =>
  apiFetch('/answers/' + id, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const patchAnswer = (id: number, data: any): Promise<Answer> =>
  apiFetch('/answers/' + id, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
export const deleteAnswer = (id: number): Promise<void> =>
  apiFetch('/answers/' + id, { method: 'DELETE' });

export const reorderAnswers = (items: Array<{ id: number; sortOrder: number }>): Promise<void> =>
  apiFetch('/answers/reorder', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(items),
  });

export const createStandardAnswers = (questionId: number): Promise<StandardAnswerCreateResponse> =>
  apiFetch(`/answers/questions/${questionId}/standard`, { method: 'POST' });
